import { CellContext, ColumnDefTemplate, flexRender, Renderable } from '@tanstack/react-table';
import { getTextContent } from '@upright/ui/common/generic/utilities/react-text-content';

/**
 * Hacky combiner to combine cell definition and context, rendering the element with server side react and parsing the text content,
 * in order to provide a speedy `column.meta.exporter: 'cell'` shortcut.
 */

export function extractTextContentOnly<T, V>(Cell: ColumnDefTemplate<CellContext<T, V>>) {
  return (_value: V, _row: T, cellContext: CellContext<T, V>) =>
    extractTextContentFromTableComponent(Cell, cellContext);
}

export function extractTextContentFromTableComponent<TProps extends object>(
  component: Renderable<TProps>,
  context: TProps,
) {
  const element = flexRender(component, context);
  return getTextContent(element as any);
}
